import { useState } from 'react';
import { Button, Center, Group, Loader, Stack } from '@mantine/core';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useOrg } from '@/auth/OrgContext';
import { errorMessage } from '@/api/errors';
import { useMembers } from '@/api/orgs';
import { EmptyState } from '@/components/EmptyState';
import { SectionDivider } from '@/components/SectionDivider';
import { usePageTitle } from '@/components/usePageTitle';
import { AddMemberModal } from '@/features/orgs/AddMemberModal';
import { MembersTable } from '@/features/orgs/MembersTable';
import { ClientShell } from '@/shells/ClientShell';

export const Route = createFileRoute('/_client/organization')({ component: OrganizationPage });

function OrganizationPage() {
  const { t } = useTranslation();
  usePageTitle(t('org.members'));
  const { current, currentRole } = useOrg();
  const { data: members, isPending, isError, error } = useMembers(current?.public_id);
  const [addOpen, setAddOpen] = useState(false);
  const canManage = currentRole === 'owner';

  return (
    <ClientShell eyebrow={current?.name} title={t('org.members')}>
      <SectionDivider label={t('org.members')} />
      {!current ? (
        <EmptyState title={t('org.members')} />
      ) : isPending ? (
        <Center py="xl">
          <Loader color="forest" />
        </Center>
      ) : isError ? (
        <EmptyState title={errorMessage(error)} />
      ) : (
        <Stack gap="md">
          {canManage && (
            <Group justify="flex-end">
              <Button onClick={() => setAddOpen(true)}>{t('org.addMember')}</Button>
            </Group>
          )}
          <MembersTable orgId={current.public_id} members={members} canManage={canManage} />
        </Stack>
      )}
      {current && <AddMemberModal orgId={current.public_id} opened={addOpen} onClose={() => setAddOpen(false)} />}
    </ClientShell>
  );
}
